export default "__VITE_ASSET__8f09104e__"